export default "__VITE_ASSET__DOMJ0MXZ__"